import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from 'providers/AppProvider';
import { STATUS } from 'consts';

export function useWaiver() {
	const ctx = useContext(AppContext);
	const { config, http } = ctx;
	const { token } = useParams();
	const [status, setStatus] = useState(token ? STATUS.UNKNOWN : STATUS.NO_ID);

	useEffect(() => {
		if (token) {
			http
				.post(`${config.API.waiver}/ApproveWaiver?waiverId=${token}`, { token })
				.then(() => setStatus(STATUS.SUCCESS))
				.catch(() => setStatus(STATUS.ERROR));
		}
	}, [token]); // eslint-disable-line

	return {
		...ctx,
		status
	};
}
